// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1PBRb","content":"styles_content__2UpGA","selectAll":"styles_selectAll__17gEp"};